(function() {

    'use strict';

    var App = function App() {};

    App.prototype.objectToParams = function(obj, prefix) {

        var parameters = [],
            self = this,
            value;

        Object.keys(obj).forEach(function(element)  {

            value = obj[element];

            if(value !== null && typeof value  === 'object') {
                parameters.push(self.objectToParams(value, prefix ? prefix + '[' + element + ']' : element));
            } else {
                parameters.push(encodeURI(prefix + '[' + element + ']=' + value));
            }

        });

        return parameters.join('&');

    };

    App.prototype.addEventListener = function(obj, type, callback) {

        if(NodeList.prototype.isPrototypeOf(obj)) {

            for(var i = 0; i < obj.length; i++) {
                obj[i].addEventListener(type, callback, false);
            }

        } else {

            obj.addEventListener(type, callback, false);

        }

    };

    App.prototype.addDelegatedListener = function(obj, selector, type, callback) {

        if(NodeList.prototype.isPrototypeOf(obj)) {

            for(var i = 0; i < obj.length; i++) {
                this.addDelegatedListener(obj[i], selector, type, callback);
            }

        } else {

            obj.addEventListener(type, function(e) {

                var target = e.target;

                if (!target) { return; }

                if (target.matches(selector)) {
                    callback(e);
                }

            }, false);

        }

    };

    App.prototype.isJSON = function(json){

        var object;

        try {
             object = JSON.parse(json);
        }
        catch (e) {
            return false;
        }

        if(object && typeof object !== 'object') {
            return false;
        }

        return object;

    };

    App.prototype.triggerEvent = function(element, name){

        var event;

        if (window.CustomEvent) {

            event = new CustomEvent(name);

        } else {

            event = document.createEvent('CustomEvent');
            event.initCustomEvent(name, true, true, {});

        }

        element.dispatchEvent(event);

    };

    App.prototype.delayExecution = (function() {

        var timer = 0;

        return function(callback, timeout) {

            clearTimeout(timer);

            timer = setTimeout(callback, timeout);

        };

    })();

    window.app = new App();

})();